import {Actions} from './WindowEventActions';

const WindowEventReducer = (state = {isLoaded:false,scroll:{x:0,y:0},size:{width:0,height:0}}, action) =>
{
	let new_state = JSON.parse(JSON.stringify(state));
	let payload = action.payload;
	switch (action.type)
	{
		case Actions.SET_LOAD:
				new_state.isLoaded=payload;
			break;
		case Actions.SET_SCROLL:
			new_state.scroll.y=payload.y;
			new_state.scroll.x=payload.x;
			break;
		case Actions.SET_SIZE:
			new_state.size.width=payload.width;
			new_state.size.height=payload.height;
			break;
	}
	return new_state;
};

export default WindowEventReducer;
